import React from 'react'

import { maskString } from 'utils/functions'

import styles from '../styles'

const BuildFamilyRelations = (props) => {
  const { familyRelationsData } = props
  const classes = styles()
  return familyRelationsData.has_conflicting_relatives ? (
    <div className={classes.familyRelation}>
      <h3>Pessoa(s) vinculada(s):</h3>
      <ul className={classes.relativeList}>
        {
          familyRelationsData.conflicting_relatives.map(relative => {
            return (
              <li key={relative.relative_data.cpf}>
                <div className={classes.relativeData}>
                  <div>
                    <p>
                      <span>Nome: </span>
                      {relative.employee_data?.full_name}
                    </p>
                    <p>
                      <span>CPF: </span>
                      {maskString(relative.relative_data?.cpf, 'cpf')}
                    </p>
                    <p>
                      <span>Email: </span>
                      {relative.employee_data?.email?.toLowerCase()}
                    </p>
                    <p>
                      <span>Gênero: </span>
                      {relative.employee_data?.gender}
                    </p>
                    <p>
                      <span>Possível Parentesco: </span>
                      {relative.relative_data?.possible_kinship?.toLowerCase()}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span>Grupo: </span>
                      {relative.employee_data?.group}
                    </p>
                    <p>
                      <span>Empresa: </span>
                      {relative.employee_data?.company_name}
                    </p>
                    <p>
                      <span>Unidade Organizacional: </span>
                      {relative.employee_data?.organizational_unity}
                    </p>
                    <p>
                      <span>Cargo: </span>
                      {relative.employee_data?.job_role}
                    </p>
                    <p>
                      <span>Senioridade: </span>
                      {relative.employee_data?.seniority}
                    </p>
                  </div>
                </div>
              </li>
            )
          })
        }
      </ul>
    </div>
  ) : (
    <div className={classes.expansibleContent}>
      <span>Nenhum registro encontrado.</span>
    </div>
  )
}

export default BuildFamilyRelations
